export const placingWayMap = {
  0:  "Иной способ (ИС)",
  1:  "Открытый конкурс (ОК)",
  2:  "Открытый аукцион (ОА)",
  3:  "Открытый аукцион в электронной форме (ЭФ)",
  4:  "Запрос котировок (ЗК)",
  5:  "Предварительный отбор (ПО)",
  6:  "Закупка у единственного поставщика (ЕП)",
  7:  "Конкурс с ограниченным участием (ОКУ)",
  8:  "Двухэтапный конкурс (ОКД)",
  9:  "Закрытый конкурс (ЗКК)",
  10: "Закрытый конкурс с ограниченным участием (ЗККУ)",
  11: "Закрытый двухэтапный конкурс (ЗККД)",
  12: "Закрытый аукцион (ЗА)",
  13: "Запрос котировок без размещения извещения (ЗКБ)",
  14: "Запрос предложений (ЗП)",
  15: "Электронный аукцион (ЭА)",
  16: "Иной многолотовый способ (ИСМ)",
  17: "Сообщение о заинтересованности в проведении открытого конкурса (СЗ)",
  18: "Иной однолотовый способ (ИОС)",
  19: "Редукцион (РЕД)",
  20: "Переторжка (ПЕР)",
  21: "Конкурентные переговоры (КП)",
  22: "Запрос котировок в электронной форме (ЗКЭФ)",
  23: "Открытый конкурс в электронной форме (ОКЭФ)",
  24: "Запрос предложений в электронной форме (ЗПЭФ)",
  25: "Конкурс с ограниченным участием в электронной форме (ОКУЭФ)",
  26: "Двухэтапный конкурс в электронной форме (ОКДЭФ)",
  27: "Запрос цен товаров, работ, услуг (ЗЦ)",
  28: "Голландский аукцион (ГА)",
  29: "Публичное предложение (ПП)",
  30: "Закупки малого объема (ЗМО)"
};

export const regionMap = {
  1: "Республика Адыгея",
  2: "Республика Башкортостан",
  3: "Республика Бурятия",
  4: "Республика Алтай",
  5: "Республика Дагестан",
  6: "Республика Ингушетия",
  7: "Кабардино-Балкарская Республика",
  8: "Республика Калмыкия",
  9: "Карачаево-Черкесская Республика",
  10: "Республика Карелия",
  11: "Республика Коми",
  12: "Республика Марий Эл",
  13: "Республика Мордовия",
  14: "Республика Саха (Якутия)",
  15: "Республика Северная Осетия - Алания",
  16: "Республика Татарстан",
  17: "Республика Тыва (Тува)",
  18: "Республика Удмуртия",
  19: "Республика Хакасия",

  21: "Чувашская Республика",
  22: "Алтайский край",
  23: "Краснодарский край",
  24: "Красноярский край",
  25: "Приморский край",
  26: "Ставропольский край",
  27: "Хабаровский край",

  28: "Амурская область",
  29: "Архангельская область",
  30: "Астраханская область",
  31: "Белгородская область",
  32: "Брянская область",
  33: "Владимирская область",
  34: "Волгоградская область",
  35: "Вологодская область",
  36: "Воронежская область",
  37: "Ивановская область",
  38: "Иркутская область",
  39: "Калининградская область",
  40: "Калужская область",
  41: "Камчатский край",
  42: "Кемеровская область",
  43: "Кировская область",
  44: "Костромская область",
  45: "Курганская область",
  46: "Курская область",
  47: "Ленинградская область",
  48: "Липецкая область",
  49: "Магаданская область",
  50: "Московская область",
  51: "Мурманская область",
  52: "Нижегородская область",
  53: "Новгородская область",
  54: "Новосибирская область",
  55: "Омская область",
  56: "Оренбургская область",
  57: "Орловская область",
  58: "Пензенская область",
  59: "Пермский край",
  60: "Псковская область",
  61: "Ростовская область",
  62: "Рязанская область",
  63: "Самарская область",
  64: "Саратовская область",
  65: "Сахалинская область",
  66: "Свердловская область",
  67: "Смоленская область",
  68: "Тамбовская область",
  69: "Тверская область",
  70: "Томская область",
  71: "Тульская область",
  72: "Тюменская область",
  73: "Ульяновская область",
  74: "Челябинская область",
  75: "Забайкальский край",
  76: "Ярославская область",

  77: "Москва",
  78: "Санкт-Петербург",
  79: "Еврейская автономная область",

  83: "Ненецкий автономный округ",
  86: "Ханты-Мансийский автономный округ",
  87: "Чукотский автономный округ",
  89: "Ямало-Ненецкий автономный округ",

  91: "Республика Крым",
  92: "Севастополь",
  95: "Чеченская Республика",
  99: "Байконур",

  80: "Донецкая Народная Республика",
  81: "Луганская Народная Республика",
  84: "Херсонская область",
  85: "Запорожская область",

  // Казахстан
  110: "Абайская область",
  111: "Акмолинская область",
  115: "Актюбинская область",
  119: "Алматинская область",
  123: "Атырауская область",
  127: "Западно-Казахстанская область",
  131: "Жамбылская область",
  133: "Жетысуская область",
  135: "Карагандинская область",
  139: "Костанайская область",
  143: "Кызылординская область",
  147: "Мангистауская область",
  151: "Туркестанская область",
  155: "Павлодарская область",
  159: "Северо-Казахстанская область",
  162: "Улытауская область",
  163: "Восточно-Казахстанская область",
  171: "Город Астана",
  175: "Город Алматы",
  179: "Город Шымкент",

  // Беларусь
  10001: "Брестская область",
  10002: "Витебская область",
  10003: "Гомельская область",
  10004: "Гродненская область",
  10005: "Минская область",
  10006: "Могилёвская область",
  10007: "Город Минск",
};
